<template>
    <div class="mobile-check-container">
        <div v-if="qrcodeVisible">
            <div>
                <div class="stepRight">
                    <div class="user" v-if="account">
                        <span v-text="account"></span>
                        <i @click="logOut">
                            <icon-logout class="icon" style="top:5px;"></icon-logout>
                        </i>
                    </div>
                    <el-button v-else type="primary" size="small" @click="login">登录</el-button>
                </div>
                <div class="stepHeader">操作指南</div>
            </div>
            <mobile-homepageheader/>
            <qriously class="qrcode_content" :value="qrcodeValue" :size="qrcodeSize"/>
        </div>
        <div v-else>
            <!-- 新添加的代码 -->
            <div v-if="showTable" class="mobile-check" style="width: 100%">
                <div class="header">
                    <el-form inline>
                        <el-form-item label="设备编号">
                            <el-input placeholder="uuid"
                                      v-model="siteInfo.uuid"
                                      style="width: 320px"
                                      size="small">
                            </el-input>
                            <p style="color:#B94A48;font-size:14px;width: auto; margin-left: 50px; float: right; ">提示:
                                此调试模式产生的日志不落数据表。</p>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="content">
                    <h2 class="g-title">调试日志</h2>
                    <!--内容头部信息-->
                    <div class="content-header">
                        <el-form inline>
                            <el-form-item label="日志类型">
                                <el-select v-model="checkedValue"
                                           multiple
                                           @change="handleCheckedChange"
                                           placeholder="请选择">
                                    <el-option v-for="option in checkOptions"
                                               :key="option.value"
                                               :label="option.text"
                                               :value="option.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="当前页面">
                                <el-tooltip effect="dark" placement="right">
                                    <div slot="content">由APP端传入，默认为ctp字段<br></div>
                                    <i class="el-icon-question"></i>
                                </el-tooltip>
                                <el-input placeholder="请输入页面标识字段"
                                          v-model="searchText.pageKeyword"
                                          style="width: 180px"
                                          suffix-icon="el-icon-search"
                                          clearable
                                          size="medium"
                                          @input="search">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="日志唯一标识">
                                <el-tooltip effect="dark" placement="right">
                                    <div slot="content">
                                        在点击日志中，表示“cls”字段值<br>
                                        在曝光日志中，表示“eid”字段值<br>
                                        在自定义日志中，表示“eid”字段值<br>
                                        在性能日志中，表示“pic_url”字段值<br>
                                        在浏览日志中，表示“page_id”字段值<br>
                                        在订单日志中，表示“sale_ord_id”字段值<br>
                                    </div>
                                    <i class="el-icon-question"></i>
                                </el-tooltip>

                                <el-input placeholder="请输入唯一标识字段"
                                          v-model="searchText.idKeyword"
                                          style="width: 180px"
                                          suffix-icon="el-icon-search"
                                          clearable
                                          size="medium"
                                          @input="search">
                                </el-input>
                            </el-form-item>
                            <el-button type="primary" @click="clearData" size="medium">清空日志</el-button>
                        </el-form>
                    </div>

                    <el-table
                        :data="tableData.data"
                        border
                        style="width: 100%">
                        <el-table-column
                            v-for="item in tableData.title"
                            :key="item.id"
                            :prop="item.prop"
                            :width="item.width"
                            align="center"
                            header-align='center'
                            :formatter="item.formatter"
                            :label="item.label">
                        </el-table-column>
                        <el-table-column
                            fixed="right"
                            label="操作"
                            width="90">
                            <template slot-scope="scope">
                                <el-button
                                    @click.native.prevent="showDetail(scope.row)"
                                    type="text"
                                    size="small">
                                    详情
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination
                    style="float:right;"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
            <div v-else>
                <div class="reminder">欢迎下次使用， 若想继续使用，请刷新当前页面。</div>
            </div>
            <el-dialog
                :title='dialogTitle'
                :visible.sync="dialogVisible"
                @close="closeDialog"
                width="60%">
                <el-tabs type="border-card">
                    <el-tab-pane label="全部字段">
                        <mobile-noteall ref="noteAllChild" :detailData="mobileData.noteAll"
                                        :isApp="mobileData.isApp"></mobile-noteall>
                    </el-tab-pane>
                    <el-tab-pane label="业务属性">
                        <mobile-noteservice :detailData="mobileData.noteService"
                                            :isApp="mobileData.isApp"></mobile-noteservice>
                    </el-tab-pane>
                    <el-tab-pane label="日志属性">
                        <mobile-noteproperty :detailData="mobileData.noteProperty"
                                             :isApp="mobileData.isApp"></mobile-noteproperty>
                    </el-tab-pane>
                    <el-tab-pane label="设备属性">
                        <mobile-notedevice :detailData="mobileData.noteDevice"
                                           :isApp="mobileData.isApp"></mobile-notedevice>
                    </el-tab-pane>
                    <el-tab-pane label="其他">
                        <mobile-noteother :detailData="mobileData.noteOther"
                                          :isApp="mobileData.isApp"></mobile-noteother>
                    </el-tab-pane>
                    <el-tab-pane label="原始数据">
                        <mobile-noteoriginal :detailData="mobileData.original"
                                             :isApp="mobileData.isApp"></mobile-noteoriginal>
                    </el-tab-pane>
                </el-tabs>
            </el-dialog>
        </div>
    </div>
</template>
<script type="text/javascript">
    import Vue from 'vue'
    import VueQriously from 'vue-qriously'
    import MobileHelper from './components/mobile-helper'
    import  "./libraries/stomp/stomp.min.js";
    Vue.use(VueQriously);
    Vue.use(MobileHelper);
    import http from './libraries/utils/http'
    import IconLogout from './components/icons/logout.vue'
    import MobileNoteall from './components/mobile-noteall'
    import MobileNoteservice from './components/mobile-noteservice'
    import MobileNoteproperty from './components/mobile-noteproperty'
    import MobileNotedevice from './components/mobile-notedevice'
    import MobileNoteother from './components/mobile-noteother'
    import MobileNoteoriginal from './components/mobile-noteoriginal'
    import MobileApptransparent from './components/mobile-apptransparent'
    import MobileSdkobtain from './components/mobile-sdkobtain'
    import MobileHomepageheader from './components/mobile-homepageheader'
    export default {
        components: {
            IconLogout,
            MobileNoteall,
            MobileNoteservice,
            MobileNoteproperty,
            MobileNotedevice,
            MobileNoteother,
            MobileApptransparent,
            MobileNoteoriginal,
            MobileSdkobtain,
            MobileHomepageheader
        },
        props: {},
        data() {
            return {
                qrcodeVisible:true, // 二维码是否显示
                siteInfo: {
                    uuid: '', code: ''
                },

                /**
                 * 用户的登录账户名
                 */
                account:'',

                showTable: true,  // 是否显示表格
                qrcodeValue: "",  // 二维码内容
                qrcodeSize: 250,  // 二维码尺寸
                searchText: {
                    idKeyword: '',
                    pageKeyword: '',
                },
                isSubscribe: false, // 判断是否已经订阅
                stompClient: null,
                checkedValue: ['all'], //选中的条件
                //选项
                checkOptions: [
                    {text: '全部', value: 'all'},
                    {text: '浏览', value: 'pv/浏览'},
                    {text: '点击', value: 'cl/点击'},
                    {text: '订单', value: 'od/订单'},
                    {text: '性能', value: 'pf/性能'},
                    {text: '自定义', value: 'ce/自定义'},
                    {text: '曝光', value: 'ep/曝光'},
                    {text: 'dau', value: 'st/dau'}
                ],
                currentPage: 1, //当前page
                total: 0,
                pageSize: 10,
                tableData: {
                    title: [
                        {
                            prop: 'ctm', label: '日志生成时间',
                            formatter: function (row, column) {
                                if (!row.ctm) {
                                    return;
                                }
                                let date = new Date(parseInt(row.ctm, 10));
                                let year = date.getFullYear();

                                let month = date.getMonth() + 1;
                                month = month < 10 ? ("0" + month) : month;

                                let day = date.getDate();
                                day = day < 10 ? ("0" + day) : day;

                                let hour = date.getHours();
                                hour = hour < 10 ? ("0" + hour) : hour;

                                let minute = date.getMinutes();
                                minute = minute < 10 ? ("0" + minute) : minute;

                                let second = date.getSeconds();
                                second = second < 10 ? ("0" + second) : second;
                                return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                            }
                        },
                        {prop: 'tmptyp', label: '日志类型', width: 120},
                        {prop: 'tmpctp', label: 'ctp/当前页面'},
                        {prop: 'tmppageid', label: '页面ID'},
                        {prop: 'tmppar', label: '当前页面参数'},
                        {prop: 'id', label: '日志唯一标识'}
                    ],
                    data: [],
                },
                mobileData: Object,
                dialogTitle: '',
                originalListData: [], //接受到的原始日志列表
                currentListData: [], //当前正在显示的表格中的全部数据
                dialogVisible: false,
                debugId: '',
                scheme:'',
                host:'',
                //公共必选字段
                mustFields: ['std', 'uid', 'app_device', 'apv']
            };
        },
        methods: {
            /**
             * 生成二维码
             */
            makeQrcode() {
                let self = this;
                http.get('/debug/code').then(resp => {
                    console.log(resp);
                    if (resp) {
                        self.debugId = resp;
                        self.scheme = 'JDAnalytics';
                        self.host = "mobileChecker";
                        self.qrcodeValue = "https:/bae.jd.com/log/demo.html?debugId=" + self.debugId +"&scheme=" + self.scheme +"&host=" + self.host;
                        //检测登录
                        self.checkLogin(resp);
                    } else {
                        self.qrcodeValue = "";
                    }
                });
            },

            /**
             * 检查登录
             */
            checkLogin(debugId) {
                let self = this;
                let myFun = function () {
                    if (debugId) {
                        http.get("/debug/checkLogin", {code: debugId}).then(status => {
                            if (status == 'success') {
                                window.timer = window.clearInterval(window.timer);
                                self.qrcodeVisible = false;
                                self.connect(debugId);
                            }
                        });
                    }
                };
                window.timer = window.setInterval(myFun, 2000);
            },

            /**
             * 创建连接
             */
            connect(debugId) {
                let socket = new SockJS('/bds-debug-websocket');
                this.stompClient = Stomp.over(socket);
                let self = this;
                this.stompClient.connect({}, function (frame) {
                    self.register(debugId);
                });
            },

            /**
             * 注册服务
             * @param debugId
             */
            register(debugId) {
                if (this.isSubscribe) {
                    return;
                }

                let self = this;
                this.stompClient.subscribe('/topic/' + debugId, function (debugMessage) {
                    if (debugMessage.body === "goodbye") {
                        //隐藏当前表格，显示提示页面
                        self.showTable = false;
                        return;
                    }
                    let messages = JSON.parse(debugMessage.body);
                    for (var j = 0, length = messages.length; j < length; j++) {
                        self.originalListData.push(JSON.parse(messages[j]));
                    }
                    self.setTableData();
                });

                this.stompClient.send("/debug/register", {}, JSON.stringify({'name': debugId}));
                this.isSubscribe = true;
            },

            /**
             * 清除数据
             */
            clearData() {
                this.tableData.data = [];
                this.currentPage = 1;
                this.total = 0;
                this.mobileData = {};
                this.checkedValue = ['all'];
                this.originalListData = [];
                this.currentListData = [];
                this.searchText.pageKeyword = '';
                this.searchText.idKeyword = '';
            },

            /**
             *
             */
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
            },

            /**
             *
             */
            handleCurrentChange(val) {
                // console.log(`当前页: ${val}`);
                let end = val * this.pageSize;
                if (end > this.total) {
                    end = this.total;
                }
                this.tableData.data = this.currentListData.slice((val - 1) * this.pageSize, end);
            },

            /**
             * 显示详情数据
             */
            showDetail(itemData) {
                this.dialogVisible = true;
                // this.detailData = this.syntaxHighlight(itemData);

                this.appendApptransparent(itemData);
            },

            appendApptransparent(itemData) {
                let mobileData = this.dealMobileData(itemData);
                this.dialogTitle = mobileData.isApp ? "移动端数据" : "Web端数据";
                this.mobileData = mobileData;
            },

            /**
             * 处理多选框选中
             */
            handleCheckedChange() {
                this.setTableData();
            },

            closeDialog() {
                this.dialogVisible = false;
                this.$refs.noteAllChild.searchNotekey = '';
            },

            /**
             * 设置表单数据
             */
            setTableData() {
                let emptyArray = [];
                this.tableData.data = [];
                for (var len = this.originalListData.length, j = len - 1; j >= 0; j--) {
                    let item = this.originalListData[j];
                    item.tmpctp = (undefined == item.ctp) ? "" : item.ctp;
                    item.tmppar = (undefined == item.par) ? "" : item.par;
                    item.tmppageid = (undefined == item.page_id) ? "" : item.page_id;
                    //pv日志
                    if (item.typ === 'pv') {
                        //对于日志中的必选字段，如果没有，则要显示出的它的key
                        if (undefined == item.page_id) {
                            item.page_id = "";
                        }
                        item.tmptyp = 'pv/浏览';
                        item.id = item.page_id;
                    } else if (item.typ === 'cl') { //点击日志
                        //对于日志中的必选字段，如果没有，则要显示出的它的key
                        if (undefined == item.cls) {
                            item.cls = "";
                        }
                        item.tmptyp = 'cl/点击';
                        item.id = item.cls;
                    } else if (item.lts === 'pf') { //性能日志
                        //对于日志中的必选字段，如果没有，则要显示出的它的key
                        if (undefined == item.pic_url) {
                            item.pic_url = "";
                        }
                        item.tmptyp = 'pf/性能';
                        item.id = item.pic_url;
                    } else if (item.lts === "od") { //订单日志
                        //对于日志中的必选字段，如果没有，则要显示出的它的key
                        if (undefined == item.sale_ord_id) {
                            item.sale_ord_id = "";
                        }
                        item.tmptyp = 'od/订单';
                        item.id = item.sale_ord_id;
                    } else if (item.typ === "ep") { //曝光日志
                        //对于日志中的必选字段，如果没有，则要显示出的它的key
                        if (undefined == item.eid) {
                            item.eid = "";
                        }
                        item.tmptyp = 'ep/曝光';
                        item.id = item.eid;
                    } else if (item.lts === "ce") { //自定义日志
                        //对于日志中的必选字段，如果没有，则要显示出的它的key
                        if (undefined == item.eid) {
                            item.eid = "";
                        }
                        item.tmptyp = 'ce/自定义';
                        item.id = item.eid;
                    } else if (item.lts === 'st') {
                        item.tmptyp = 'st/dau';
                    }

                    if (this.siteInfo.code.length == 0) {
                        this.siteInfo.code = item.std;
                    }

                    if (this.siteInfo.uuid.length == 0) {
                        this.siteInfo.uuid = item.uid;
                    }
                    //判断日志中那些必选字段是否上报了，如果没有，则要显示出的它的key\
                    for (var q = 0, length = this.mustFields.length; q < length; q++) {
                        if (undefined == item[q]) {
                            item[q] == "";
                        }
                    }
                    if (this.checkedValue.indexOf("all") != -1) {
                        if (this.searchText.idKeyword) {
                            if (item.id.indexOf(this.searchText.idKeyword) != -1) {
                                emptyArray.push(item);
                            }
                        } else if (this.searchText.pageKeyword) {
                            if (item.tmpctp.indexOf(this.searchText.pageKeyword) != -1) {
                                emptyArray.push(item);
                            }
                        } else {
                            emptyArray.push(item);
                        }
                    } else {
                        if (this.checkedValue.indexOf(item.tmptyp) != -1 || this.checkedValue.indexOf(item.lts) != -1) {
                            if (this.searchText.idKeyword) {
                                if (item.id.indexOf(this.searchText.idKeyword) != -1) {
                                    emptyArray.push(item);
                                }
                            } else if (this.searchText.pageKeyword) {
                                if (item.tmpctp.indexOf(this.searchText.pageKeyword) != -1) {
                                    emptyArray.push(item);
                                }
                            } else {
                                emptyArray.push(item);
                            }
                        }
                    }
                }
                this.currentPage = 1;
                this.tableData.data = emptyArray.length <= 10 ? emptyArray : emptyArray.slice(0, 10);
                this.currentListData = emptyArray;
                this.total = this.currentListData.length;
            },

            /**
             * 搜索内容
             */
            search() {
                this.setTableData();
            },

            /**
             * 搜索输入框，内容发生变化
             */
            change(value) {
                if (!value) {
                    this.setTableData();
                }
            },

            /**
             *  下载数据
             */
            downloadTable() {
                this.setTableData();
            },

            /**
             * 登录
             */
            login(){
                window.location = "https://passport.jd.com/uc/login?ReturnUrl=http%3A%2F%2Fbulls.jd.com%2F";
            },

            /**
             * 退出登录
             */
            logOut() {
                this.account = "";
                window.location = "https://passport.jd.com/uc/login?ltype=logout";
            },

            /**
             * 查询当前登录用户的账户名
             */
            getUserInfo() {
                http.get('/debug/getUserInfo').then(resp => {
                    this.account = resp;
                    this.sendLog();
                });
            },

            sendLog() { //发埋点，暂时先保持用joya埋点后续需要用支持单页应用的埋点方案替换
                if(window.jap) { return; }
                let jaq = jaq || [];
                jaq.push(['account', 'JA2019_1232090']); //站点编号
                jaq.push(['domain', 'jd.com']);  //站点域名
                jaq.push(['anchorpvflag','true']);
                jaq.push(['anchorToUri',1]);
                window.jaq = jaq;
                let ja = document.createElement('script');
                ja.type = 'text/javascript';
                ja.async = true;
                ja.src = 'https://wl.jd.com/joya.js';
                let s = document.getElementsByTagName('script')[0];
                s.parentNode.insertBefore(ja, s);
            },
        },

        mounted(){
            this.getUserInfo();
        },

        created() {
            this.makeQrcode();
        }
    }
</script>
<style lang="scss">
    .mobile-check-container {
        height: 100%;
        background: #FFFFFF !important;

        .stepRight {
            float:right;
            width:100px;
            height:60px;
            line-height:60px;
            vertical-align: middle;
        }

        .stepHeader {
            text-align: center !important;
            border-bottom: none !important;
            height: 60px;
            width:100px;
            margin-left: auto;
            margin-right: auto;
            line-height: 60px;
            font-weight: bold;
        }

        .qrcode_content {
            text-align: center;
            margin: 20px auto 0;
        }

        .mobile-check {
            .header {
                width: 100%;
                box-shadow: 0 0 2px 0 rgba(172, 169, 178, 0.50);
                padding: 10px 15px;
                height: 60px;

                .el-form {
                    float: left;
                }
            }

            .content {
                width: 100%;
                height: calc(100% - 70px);
                box-shadow: 0 0 2px 0 rgba(172, 169, 178, 0.50);
                overflow: hidden;

                .el-table {
                    margin: 10px;
                }

                .content-header {
                    width: 100%;
                    box-shadow: 0 0 2px 0 rgba(172, 169, 178, 0.50);
                    padding: 10px 15px;
                    height: 60px;

                    .el-form {
                        float: left;
                    }

                    .el-select__input {
                        vertical-align: top;
                    }
                }
            }
        }

        .reminder {
            text-align: center;
            margin-top: 50px;
            color: #D35400
        }

        .el-dialog__body {
            overflow-y: auto !important;
        }

        .user {
            float: right;
            height: 60px;
            line-height:60px;
            > span {
                margin-right: 20px;
            }
        }
    }
</style>
